import React, { useState } from 'react';
import { Fish, RefreshCw, CheckCircle, AlertCircle } from 'lucide-react';
import { useAuth } from '@clerk/clerk-react';

const API_BASE = process.env.REACT_APP_API_URL || '';

export default function OpenPhishSyncPanel({ onSyncComplete }) {
  const { getToken } = useAuth();
  const [syncing, setSyncing] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

 const handleSync = async () => {
    setSyncing(true);
    setResult(null);
    setError(null);
    try {
      const token = await getToken();
      const res = await fetch(`${API_BASE}/api/iocs/sync/openphish`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
      setResult(data);
      if (onSyncComplete) onSyncComplete();
    } catch (err) {
      console.error('🐟 OpenPhish sync error:', err);
      setError(err.message);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-cyan-500/10 rounded-lg">
            <Fish className="w-5 h-5 text-cyan-400" />
          </div>
          <div>
            <h3 className="text-white font-semibold">OpenPhish Feed</h3>
            <p className="text-slate-400 text-xs">Public phishing URL feed (research only)</p>
          </div>
        </div>
        <button
          onClick={handleSync}
          disabled={syncing}
          className="flex items-center gap-2 px-4 py-2 bg-cyan-600 hover:bg-cyan-700 disabled:bg-slate-600 disabled:cursor-not-allowed text-white text-sm font-medium rounded-lg transition"
        >
          <RefreshCw className={`w-4 h-4 ${syncing ? 'animate-spin' : ''}`} />
          {syncing ? 'Syncing...' : 'Sync Now'}
        </button>
      </div>

      {result && (
        <div className="flex items-start gap-2 p-3 bg-green-500/10 border border-green-500/30 rounded text-sm text-green-300">
          <CheckCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <div className="font-medium">Sync complete</div>
            {result.output && (
              <pre className="text-xs text-green-200/80 mt-1 whitespace-pre-wrap max-h-32 overflow-y-auto">
                {result.output.split('\n').slice(-6).join('\n')}
              </pre>
            )}
          </div>
        </div>
      )}

      {error && (
        <div className="flex items-start gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded text-sm text-red-300">
          <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
}